export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full min-h-screen overflow-hidden bg-background-50">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage:
            "url(https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/cb43db14c54470be4f999f19f3077426.jpeg)",
          backgroundPosition: "calc(50% + 76px) center",
        }}
      />
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-white/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-white/50 via-transparent to-white/20" />


      {/* Floating product hint - bottom right */}
      <div className="absolute bottom-24 right-6 md:right-10 z-20 hidden lg:block">
        <div className="flex items-center gap-3 bg-background-50/60 backdrop-blur-md border border-background-200/40 rounded-full pl-4 pr-2 py-2">
          <div className="text-right">
            <div className="text-[10px] tracking-[0.3em] text-primary-500">雷撃カゴ</div>
            <div className="text-xs text-foreground-900">実釣フィールド / 日本海 山陰エリア</div>
          </div>
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-map-pin-2-line text-sm"></i>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-between min-h-screen w-full px-6 md:px-10 pt-32 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start flex-1">
          <div className="lg:col-span-8 flex flex-col justify-center h-full">
            {/* Micro label */}
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-lg md:text-2xl tracking-[0.2em] font-bold"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                世界初、3Dプリンターによるカゴウキ作成に成功！
              </span>
            </div>

            {/* Main headline */}
            <h1 className="font-heading text-foreground-950 leading-[0.85]">
              <span className="block text-[22vw] md:text-[16rem] lg:text-[20rem] tracking-tighter text-shadow-glow">
                飛<span className="text-primary-500">ぶ</span>。
              </span>
              <span
                className="block text-3xl md:text-5xl lg:text-6xl tracking-[0.15em] mt-2 text-primary-500 font-black"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                雷撃カゴ
              </span>
            </h1>

            <p className="mt-8 max-w-xl text-foreground-700 text-base md:text-lg leading-relaxed font-bold">
              3Dプリント技術が導き出した、圧倒的な飛距離と究極の安定性。
              <br />
              空を裂き、狙いのポイントへ雷撃のごとく突き刺さる次世代カゴウキ。
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollTo("#technology")}
                className="group inline-flex items-center gap-4 pl-6 pr-2 py-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 transition whitespace-nowrap cursor-pointer"
              >
                <span
                  className="text-sm tracking-[0.3em]"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  技術を見る
                </span>
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 text-primary-500 group-hover:rotate-45 transition-transform">
                  <i className="ri-arrow-right-up-line text-xl"></i>
                </span>
              </button>

              <button
                onClick={() => scrollTo("#products")}
                className="inline-flex items-center gap-3 px-6 py-4 rounded-full border border-foreground-300/40 text-foreground-900 hover:border-primary-500 hover:text-primary-500 transition whitespace-nowrap cursor-pointer text-sm tracking-[0.3em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                <span>実釣性能</span>
              </button>
            </div>
          </div>

          {/* Right side info panel */}
          <div className="lg:col-span-4 flex lg:flex-col justify-between lg:justify-end lg:items-end gap-6 lg:h-full lg:pt-24">
            <div className="max-w-xs text-right hidden lg:block">
              <div className="text-[10px] tracking-[0.4em] text-foreground-9500 mb-3">
                MADE IN SHIMANE / 3D PRINTED
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                釣り人のための、釣り人による、島根発の3Dプリント釣具ブランド。プロトタイプは既に山陰のフィールドで実戦投入中。
              </p>
            </div>
          </div>
        </div>

        {/* Bottom catchphrase */}
        <div className="mt-12 lg:mt-16 border-t border-background-300/60 pt-8 flex items-center justify-center">
          <div className="flex items-center gap-4">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span
              className="text-primary-500 text-xs tracking-[0.4em]"
              style={{ fontFamily: "var(--font-label)" }}
            >
              HAYABUSA WORKS / 雷撃カゴ
            </span>
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          </div>
        </div>
      </div>
    </section>
  );
}